import Button from 'packages/novous_web/src/common/components/Button';
import CustomDropDownInput from 'packages/novous_web/src/common/components/customDropDownInput';
import InputField from 'packages/novous_web/src/common/components/InputField';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Modal, Typography } from '@mui/material';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import DateField from 'packages/novous_web/src/common/components/DateField';
import dayjs from 'dayjs';
import CustomMultiSelectDropDown from 'packages/novous_web/src/common/components/CustomMultiSelectDropDownInput';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useAxios from 'packages/novous_web/src/api/useAxios';
import useApiError from 'packages/novous_web/src/api/useApiError';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import InternalOrderDetailsTable from './InternalOrderDetailsTable';

interface SubscriptionFormFleetProps {
  handleActiveState?: (step: number) => void;
  isSummaryView: boolean;
  setIsSummaryView: (val: boolean) => void;
  activeStep: number;
  setActiveStep: (step: number) => void;
}

interface CompanyData {
  id: string;
  name: string;
  description: string;
  type: string;
  crn: string;
  address: {
    fullAddress: string;
    city: string;
    state: string;
    pincode: number;
    country: string;
  };
  contacts: {
    telephoneNo: string;
    mobileNo: string;
    email: string;
  };
  url: string;
  status: number;
  deviceTypes: string[] | null;
}

const InternalSubscriptionForm: React.FC<SubscriptionFormFleetProps> = ({
  handleActiveState,
  isSummaryView,
  setIsSummaryView,
  activeStep,
  setActiveStep,
}) => {
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const navigate = useNavigate();
  const [formData, setFormData] = useState<{
    selectItem: string;
    selectDeviceType: string;
    selectQuantity: string;
    SelectDurationValue: string;
    SelectDurationUnit: string;
    startDate: string | null;
    selectedDevice: string[];
    userName: string;
    price: string;
  }>({
    selectItem: '',
    selectDeviceType: '',
    selectQuantity: '',
    SelectDurationValue: '',
    SelectDurationUnit: 'Years',
    startDate: null,
    selectedDevice: [],
    userName: '',
    price: '',
  });

  const [submittedData, setSubmittedData] = useState<
    Array<{
      item: string;
      selectDeviceType: string;
      quantity: number;
      duration: number;
      startDate: string | null;
      selectedDevice: string[];
      userName: string;
      price: number;
    }>
  >([]);

  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { user } = useAuth();
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [isUserSelected, setIsUserSelected] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<number | null>(null);
  const [filteredDevices, setFilteredDevices] = useState<any[]>([]);

  const {
    data: companyListByCrn,
    error: companyListByCrnError,
    loading: companyListByCrnLoading,
    fetchData: fetchCompanyListByCrnData,
  } = useAxios<any>(`${API_ENDPOINTS.users.CUSTOMER_LIST_CRN}`, 'POST');

  const {
    data: productItems,
    error: productItemsError,
    loading: productItemsLoading,
    fetchData: fetchproductItemsData,
  } = useAxios<any>(`${API_ENDPOINTS.clientSubscription.PRODUCT_ITEMS}`, 'GET');

  const {
    data: deviceType,
    error: deviceTypeError,
    loading: deviceTypeLoading,
    fetchData: fetchdeviceTypeData,
  } = useAxios<any>(`${API_ENDPOINTS.clientSubscription.DEVICE_ITEM_TYPE}`, 'GET');

  const {
    data: allVehicles,
    error: allVehiclesError,
    loading: allVehiclesLoading,
    fetchData: fetchallVehiclesData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.GET_ALL_VEHICLES}`, 'POST');

  const {
    data: companyListByCrnDevices,
    error: companyListByCrnDevicesError,
    loading: companyListByCrnDevicesLoading,
    fetchData: fetchCompanyListByCrnDevicesData,
  } = useAxios<any>(`${API_ENDPOINTS.users.CUSTOMER_LIST_DEVICES}`, 'POST');

  const {
    data: clientSubscriptionCreate,
    error: clientSubscriptionCreateError,
    loading: clientSubscriptionCreateLoading,
    fetchData: fetchclientSubscriptionCreateData,
  } = useApiError<any>(`${API_ENDPOINTS.clientSubscription.CREATE_SUBSCRIPTION}`, 'POST');

  const {
    data: companyList,
    error: companyListError,
    loading: companyListLoading,
    fetchData: fetchCompanyListData,
  } = useAxios<any>(`${API_ENDPOINTS.users.COMPANY_LIST}`, 'GET');

  useEffect(() => {
    if (user?.authorities === 'ROLE_SUPER_ADMIN') {
      fetchCompanyListData();
    }
  }, [user]);

  useEffect(() => {
    if (user?.authorities === 'ROLE_SUPER_ADMIN' && selectedCompany) {
      fetchCompanyListByCrnData({
        userId: selectedCompany?.id,
        userCrn: selectedCompany?.crn,
      });
    }
  }, [user, selectedCompany]);

  const handleCompanyChange = (value: string) => {
    const companySelected = companyList?.data?.find((company: any) => company.id === value);
    setSelectedCompany(companySelected || null);
    setFormData((prev) => ({ ...prev, selectedCompanyId: value }));
    setSelectedUser(null);
    setIsUserSelected(false);
    setFormData((prev) => ({ ...prev, userName: '' }));
  };

  const handleUserChange = (value: string) => {
    const userSelected = companyListByCrn?.data?.find((u: any) => u.fullName === value);
    setSelectedUser(userSelected || null);
    setIsUserSelected(!!userSelected);
    setFormData((prev) => ({ ...prev, userName: value }));
  };

  const handleUserSelection = () => {
    if (selectedUser) {
      if (handleActiveState) handleActiveState(1);
    } else {
      setToast({ open: true, message: 'Please select a user', type: 'error' });
    }
  };

  useEffect(() => {
    fetchproductItemsData();
  }, []);

  useEffect(() => {
    fetchdeviceTypeData();
  }, []);

  const companyOptions =
    companyList?.data?.map((company: any) => ({
      label: company.name,
      value: company.id,
    })) || [];

  const productItemOptions =
    productItems?.data?.map((item: any) => ({
      label: item.name,
      value: item.name,
      description: item.description,
    })) || [];

  const deviceTypeOptions =
    deviceType?.data?.map((item: any) => ({
      label: item.name,
      value: item.name,
      description: item.description,
    })) || [];

  useEffect(() => {
    if (selectedUser?.customer_id) {
      fetchCompanyListByCrnDevicesData({
        fleetId: selectedUser.customer_id,
      });
    }
  }, [selectedUser]);

  // Function to filter devices based on selected device type
  const filterDevicesByType = (devices: any[], selectedDeviceType: string) => {
    if (!selectedDeviceType || !devices) return devices;

    switch (selectedDeviceType) {
      case 'NOVUS LITE':
        return devices.filter((device) => device.camCount <= 2 && device.dataSource === 'vp2');

      case 'NOVUS LITE MAX':
        return devices.filter((device) => device.camCount > 2 && device.dataSource === 'vp2');

      case 'NOVUS PRO':
        return devices.filter((device) => device.camCount <= 2 && device.dataSource !== 'vp2');

      case 'NOVUS PRO MAX':
        return devices.filter((device) => device.camCount > 2 && device.dataSource !== 'vp2');

      default:
        return devices;
    }
  };

  // Update filtered devices when device type or device list changes
  useEffect(() => {
    if (companyListByCrnDevices?.data && formData.selectDeviceType) {
      const filtered = filterDevicesByType(companyListByCrnDevices.data, formData.selectDeviceType);
      setFilteredDevices(filtered);

      // Also clear selected devices if the filtered list doesn't include them
      const currentSelected = formData.selectedDevice;
      const validSelected = currentSelected.filter((id) => filtered.some((device) => device.deviceId === id));

      if (validSelected.length !== currentSelected.length) {
        setFormData((prev) => ({ ...prev, selectedDevice: validSelected }));
      }
    } else {
      setFilteredDevices(companyListByCrnDevices?.data || []);
    }
  }, [companyListByCrnDevices?.data, formData.selectDeviceType]);

  const CustomOption = (props: any) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} className="p-2 hover:bg-gray-100">
        <div className="font-semibold text-sm">{data.label}</div>
        <div className="text-xs text-gray-500">{data.description}</div>
      </div>
    );
  };

  const handleNext = async () => {
    const payload = submittedData.map((order) => ({
      fleetAdminId: selectedCompany?.id,
      fleetId: selectedUser?.customer_id,
      productItem: order.item,
      deviceType: order.selectDeviceType,
      quantity: order.quantity,
      durations: order.duration,
      startDate: order.startDate ? dayjs(order.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
      deviceIds: order.selectedDevice,
      userName: order.userName,
      price: order.price,
      channelType: true,
    }));

    try {
      const response = await fetchclientSubscriptionCreateData(payload);
      if (response?.status === 200 || response?.status === 201) {
        setToast({ open: true, message: response.message, type: 'success' });
        setTimeout(() => {
          navigate('/admin/internal-subscriptions');
        }, 500);
      } else {
        setToast({ open: true, message: response.message, type: 'error' });
      }
    } catch (error: any) {
      setToast({ open: true, message: 'Error Occured while creating subscription', type: 'error' });
    }
  };

  useEffect(() => {
    if (clientSubscriptionCreateError) {
      setToast({ open: true, message: clientSubscriptionCreateError, type: 'error' });
    }
  }, [clientSubscriptionCreateError]);

  const handleViewSummary = () => {
    if (!submittedData.length) {
      setToast({ open: true, message: 'Please add at least one item', type: 'error' });
      return;
    }
    if (handleActiveState) handleActiveState(2);
    setIsSummaryView(true);
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
      setIsSummaryView(activeStep - 1 === 2);
    } else {
      navigate(-1);
    }
  };

  const calculateDurationInSeconds = (
    durationValue: string,
    durationUnit: string,
    startDate: string | null,
  ): number => {
    const val = parseInt(durationValue, 10);
    if (isNaN(val) || !startDate) return 0;

    const start = dayjs(startDate);

    switch (durationUnit.toLowerCase()) {
      case 'years':
        return val * 365 * 24 * 60 * 60;
      case 'months': {
        let totalSeconds = 0;
        for (let i = 0; i < val; i++) {
          let monthDate = start.add(i, 'month');
          if (!monthDate.isValid()) {
            const tempMonth = start.add(i, 'month');
            monthDate = dayjs(
              `${tempMonth.year()}-${(tempMonth.month() + 1).toString().padStart(2, '0')}-01`,
            ).endOf('month');
          }

          const daysInMonth = monthDate.daysInMonth();
          totalSeconds += daysInMonth * 24 * 60 * 60;
        }
        return totalSeconds;
      }

      case 'days':
        return val * 24 * 60 * 60;
      default:
        return 0;
    }
  };

  const handleEdit = (data: any, index: number) => {
    const itemValue = productItemOptions.find((opt: { label: any }) => opt.label === data.item)?.value;

    const durationValue = data.SelectDurationValue || '';
    const durationUnit = data.SelectDurationUnit || 'Years';

    const quantity = typeof data.quantity === 'number' ? data.quantity : parseInt(data.quantity, 10);
    const selectedDevicesCount = data.selectedDevice?.length || 0;

    if (selectedDevicesCount > quantity) {
      setToast({
        open: true,
        message: `Warning: This item has ${selectedDevicesCount} devices selected but quantity is only ${quantity}. Please adjust the devices before saving.`,
        type: 'warning',
      });
    }

    setFormData({
      selectItem: itemValue !== undefined ? itemValue.toString() : '',
      selectDeviceType: data.selectDeviceType,
      selectQuantity: typeof data.quantity === 'number' ? data.quantity.toString() : '',
      SelectDurationValue: durationValue,
      SelectDurationUnit: durationUnit,
      startDate: data.startDate,
      selectedDevice: data.selectedDevice || [],
      userName: data.userName,
      price: data.price,
    });

    setEditIndex(index);
    setIsEditing(true);
    setIsEditModalOpen(true);
  };

  const handelFormSubmit = () => {
    const fullDuration = `${formData.SelectDurationValue} ${formData.SelectDurationUnit}`;
    const quantityValid = /^\d+$/.test(formData.selectQuantity);
    const durationValid = /^\d+$/.test(formData.SelectDurationValue);

    if (!quantityValid || !durationValid) {
      setToast({
        open: true,
        message: 'Please use proper numbers, no characters or special characters or decimals.',
        type: 'error',
      });
      return;
    }

    const quantity = parseInt(formData.selectQuantity, 10);
    const selectedDevicesCount = formData.selectedDevice.length;

    if (selectedDevicesCount > quantity) {
      setToast({
        open: true,
        message: `You have selected ${selectedDevicesCount} devices but quantity is only ${quantity}. Please reduce the number of devices or increase the quantity.`,
        type: 'error',
      });
      return;
    }

    const selectedItem = productItemOptions.find(
      (item: { value: { toString: () => string } }) =>
        item.value.toString() === formData.selectItem?.toString(),
    );
    const selectedDeviceType = deviceTypeOptions.find(
      (item: { value: { toString: () => string } }) =>
        item.value.toString() === formData.selectDeviceType?.toString(),
    );

    const durationInSeconds = calculateDurationInSeconds(
      formData.SelectDurationValue,
      formData.SelectDurationUnit,
      formData.startDate,
    );

    const payload = {
      item: selectedItem?.label || '',
      selectDeviceType: selectedDeviceType?.label || '',
      quantity: parseInt(formData.selectQuantity, 10),
      duration: durationInSeconds,
      startDate: formData.startDate,
      selectedDevice: formData.selectedDevice,
      SelectDurationValue: formData.SelectDurationValue,
      SelectDurationUnit: formData.SelectDurationUnit,
      userName: formData.userName,
      price: parseInt(formData.price, 10),
    };

    if (isEditing && editIndex !== null) {
      const updatedList = [...submittedData];
      updatedList[editIndex] = payload;
      setSubmittedData(updatedList);
    } else {
      setSubmittedData([...submittedData, payload]);
    }

    setIsEditModalOpen(false);
    setIsEditing(false);
    setEditIndex(null);
    setFormData({
      selectItem: '',
      selectDeviceType: '',
      selectQuantity: '',
      SelectDurationValue: '',
      SelectDurationUnit: 'Years',
      startDate: null,
      selectedDevice: [],
      userName: '',
      price: '',
    });
  };

  const handelDeleteConfirmation = (index: number) => {
    setItemToDelete(index);
    setIsDeleteModalOpen(true);
  };

  const handleDelete = (index: number) => {
    if (itemToDelete !== null) {
      const updatedList = submittedData.filter((_, i) => i !== index);
      setSubmittedData(updatedList);
      setItemToDelete(null);
      setIsDeleteModalOpen(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 h-full justify-between">
      <div className="flex flex-col gap-4">
        {/* Step 1: Customer Selection */}
        {activeStep === 0 && (
          <div className="relative grid grid-cols-2 rounded-lg gap-4 mt-8">
            <CustomDropDownInput
              label="Select Company"
              options={companyOptions}
              value={selectedCompany?.id || ''}
              onChange={handleCompanyChange}
              placeholder="Select Company"
              showDropdownArrow={true}
              isMandatory
            />
            <CustomDropDownInput
              label="Select Customer"
              options={
                companyListByCrn?.data?.map((user: any) => ({
                  value: user.fullName,
                  label: user.fullName,
                })) || []
              }
              value={selectedUser?.fullName || ''}
              onChange={handleUserChange}
              placeholder="Select Customer"
              showDropdownArrow={true}
              isDisabled={!selectedCompany}
              isMandatory
            />
          </div>
        )}

        {/* Step 2: Order Details */}
        {activeStep === 1 && !isSummaryView && (
          <>
            <div className="relative grid grid-cols-2 rounded-lg gap-4 mt-8">
              <CustomDropDownInput
                label="Select Product Item"
                placeholder="Select Product Item"
                options={productItemOptions}
                value={formData.selectItem}
                onChange={(e: any) => setFormData({ ...formData, selectItem: e })}
                showDropdownArrow
                components={{ Option: CustomOption }}
                isDisabled={!isUserSelected}
                isMandatory
              />
              <CustomDropDownInput
                label="Select Device Type"
                placeholder="Select Device Type"
                options={deviceTypeOptions}
                value={formData.selectDeviceType}
                onChange={(e: any) => setFormData({ ...formData, selectDeviceType: e })}
                showDropdownArrow
                components={{ Option: CustomOption }}
                isDisabled={!isUserSelected}
                isMandatory
              />
              <InputField
                label="Enter Quantity"
                placeholder="Enter Quantity"
                type="number"
                value={formData.selectQuantity}
                onChange={(e: any) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setFormData({ ...formData, selectQuantity: value });
                }}
                showIncrementButtons={true}
                isDisabled={!isUserSelected}
                isMandatory
              />
              <InputField
                label="Enter Duration"
                placeholder="Enter duration"
                type="number"
                value={formData.SelectDurationValue}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setFormData({ ...formData, SelectDurationValue: value });
                }}
                showTimeUnitDropdown={true}
                timeUnitValue={formData.SelectDurationUnit}
                onTimeUnitChange={(val) => setFormData({ ...formData, SelectDurationUnit: val })}
                isDisabled={!isUserSelected}
                isMandatory
              />
              <DateField
                label="Start Date"
                name="startDate"
                value={formData.startDate}
                onChange={(date) => setFormData({ ...formData, startDate: date })}
                minDate={dayjs()}
                isDisabled={!isUserSelected}
                isMandatory={true}
              />
              <CustomMultiSelectDropDown
                options={filteredDevices.map((device: any) => ({
                  value: device.deviceId,
                  label: `${device.deviceId}`,
                }))}
                value={formData.selectedDevice}
                label="Select Device"
                placeholder="Select Device"
                onChange={(e: any) => setFormData({ ...formData, selectedDevice: e })}
                showDropdownArrow
                isDisabled={!isUserSelected || !formData.selectDeviceType}
                isMandatory
              />
              <InputField
                label="Enter Price"
                placeholder="Enter Price"
                type="number"
                value={formData.price}
                onChange={(e: any) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setFormData({ ...formData, price: value });
                }}
                isDisabled={!isUserSelected}
                isMandatory
              />
            </div>
            <div className="flex justify-end">
              <Button
                text="Add Item"
                onClick={handelFormSubmit}
                fullWidth={false}
                disabled={
                  !isUserSelected ||
                  !formData.selectItem ||
                  !formData.selectQuantity ||
                  parseInt(formData.selectQuantity, 10) <= 0 ||
                  !formData.SelectDurationValue ||
                  parseInt(formData.SelectDurationValue, 10) <= 0 ||
                  !formData.startDate ||
                  formData.selectedDevice.length === 0 ||
                  !formData.price ||
                  parseInt(formData.price, 10) <= 0 ||
                  !formData.selectDeviceType
                }
              />
            </div>
          </>
        )}

        {(activeStep === 1 || activeStep === 2) && (
          <InternalOrderDetailsTable
            formData={submittedData}
            isSummaryView={isSummaryView}
            onEdit={handleEdit}
            onDelete={handelDeleteConfirmation}
            onUpdateVehicles={(orderIndex, updatedVehicles) => {
              const updatedList = [...submittedData];
              updatedList[orderIndex] = {
                ...updatedList[orderIndex],
                selectedDevice: updatedVehicles,
              };
              setSubmittedData(updatedList);
            }}
          />
        )}

        <Modal open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '440px',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 4,
            }}
          >
            <Typography variant="h6" sx={{ color: (theme) => theme.palette.text.primary }}>
              Delete Item
            </Typography>
            <Typography variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
              Are you sure you want to delete the item? This action cannot be undone.
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <CustomIconButton
                text="Cancel"
                onClick={() => setIsDeleteModalOpen(false)}
                variant="outlined"
                background="transparent"
              />
              <CustomIconButton
                text="Delete"
                onClick={() => itemToDelete?.toString() && handleDelete(itemToDelete)}
                background="error"
                outline={false}
              />
            </Box>
          </Box>
        </Modal>
        <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '640px',
              maxHeight: '90vh',
              overflowY: 'auto',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 4,
            }}
          >
            <Typography variant="h6" sx={{ color: (theme) => theme.palette.text.primary }}>
              {isEditing ? 'Edit Item' : 'Add Item'}
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomDropDownInput
                label="Select Customer"
                options={
                  companyListByCrn?.data?.map((user: any) => ({
                    value: user.fullName,
                    label: user.fullName,
                  })) || []
                }
                value={formData.userName}
                onChange={(value: string) => setFormData((prev) => ({ ...prev, userName: value }))}
                placeholder="Select Customer"
                showDropdownArrow={true}
              />
              <CustomDropDownInput
                label="Select Product Item"
                placeholder="Select Product Item"
                options={productItemOptions}
                value={formData.selectItem}
                onChange={(e: any) => setFormData({ ...formData, selectItem: e })}
                showDropdownArrow
                components={{ Option: CustomOption }}
              />
              <CustomDropDownInput
                label="Select Device Type"
                placeholder="Select Device Type"
                options={deviceTypeOptions}
                value={formData.selectDeviceType}
                onChange={(e: any) => setFormData({ ...formData, selectDeviceType: e })}
                showDropdownArrow
                components={{ Option: CustomOption }}
                isDisabled={!isUserSelected}
              />
              <InputField
                label="Enter Quantity"
                placeholder="Enter Quantity"
                type="number"
                value={formData.selectQuantity}
                onChange={(e: any) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setFormData({ ...formData, selectQuantity: value });
                }}
                showIncrementButtons={true}
              />
              <InputField
                label="Enter Duration"
                placeholder="Enter duration"
                type="number"
                value={formData.SelectDurationValue}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setFormData({ ...formData, SelectDurationValue: value });
                }}
                showTimeUnitDropdown={true}
                timeUnitValue={formData.SelectDurationUnit}
                onTimeUnitChange={(val) => setFormData({ ...formData, SelectDurationUnit: val })}
              />
              <DateField
                label="Start Date"
                name="startDate"
                value={formData.startDate}
                onChange={(date) => setFormData({ ...formData, startDate: date })}
                minDate={dayjs()}
              />
              <CustomMultiSelectDropDown
                options={filteredDevices.map((device: any) => ({
                  value: device.deviceId,
                  label: `${device.deviceId}`,
                }))}
                value={formData.selectedDevice}
                label="Select Device"
                onChange={(e: any) => setFormData({ ...formData, selectedDevice: e })}
                showDropdownArrow
                isDisabled={!isUserSelected || !formData.selectDeviceType}
              />
              <InputField
                label="Enter Price"
                placeholder="Enter Price"
                type="number"
                value={formData.price}
                onChange={(e: any) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setFormData({ ...formData, price: value });
                }}
                isDisabled={!isUserSelected}
              />
            </Box>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <CustomIconButton
                text="Cancel"
                onClick={() => setIsEditModalOpen(false)}
                variant="outlined"
                background="transparent"
              />
              <Button
                text="Save Changes"
                onClick={handelFormSubmit}
                fullWidth={false}
                disabled={
                  !formData.selectItem ||
                  !formData.selectQuantity ||
                  !formData.SelectDurationValue ||
                  !formData.price
                }
              />
            </Box>
          </Box>
        </Modal>
      </div>

      <div className="flex justify-between w-full gap-4 mb-4">
        <CustomIconButton text="Back" onClick={handleBack} variant="outlined" background="transparent" />
        {activeStep === 0 && (
          <Button text="Next" onClick={handleUserSelection} fullWidth={false} disabled={!selectedUser} />
        )}
        {activeStep === 1 && (
          <Button
            text="View Summary"
            onClick={handleViewSummary}
            disabled={!submittedData.length}
            fullWidth={false}
          />
        )}
        {activeStep === 2 && isSummaryView && (
          <Button
            text="Continue"
            onClick={handleNext}
            fullWidth={false}
            disabled={clientSubscriptionCreateLoading}
          />
        )}
      </div>

      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
      />
    </div>
  );
};

export default InternalSubscriptionForm;
